import { DomSanitizer } from '@angular/platform-browser';
import { Paragraph } from '../../shared/models/internal/popover/paragraph';
import { ICONS_RAW } from '../../shared/constants/icons-raw';

export function buildTranslationStateColorsHelp(sanitizer: DomSanitizer): Paragraph[] {
  return [
    {
      title: 'Translation State Colors',
      header: sanitizer.bypassSecurityTrustHtml(ICONS_RAW.translationMissingColor),
      content: 'Translation missing',
    },
    {
      header: sanitizer.bypassSecurityTrustHtml(ICONS_RAW.translated),
      content: 'Translated',
    },
    {
      header: sanitizer.bypassSecurityTrustHtml(ICONS_RAW.manuallyTranslated),
      content: 'Manually translated',
    },
    {
      header: sanitizer.bypassSecurityTrustHtml(ICONS_RAW.mainLanguage),
      content: 'Main language',
    },
    {
      header: sanitizer.bypassSecurityTrustHtml(ICONS_RAW.mainLanguageUpdated),
      content: 'Main language updated',
    },
    {
      header: sanitizer.bypassSecurityTrustHtml(ICONS_RAW.translationPending),
      content: 'Translation pending',
    },
    {
      header: sanitizer.bypassSecurityTrustHtml(ICONS_RAW.translationPartially),
      content: 'Partially translated',
    },
  ];
}
